export enum DetailsHeroSectionType {
	agreement,
	medicalOffice,
	employee,
	patient,
	specialty,
	provider,
	channel,
}
